import enUS from './en-US/en-US';
// import zhCN from './zh-CN/zh-CN';
// import jaJP from './ja-JP/ja-JP';
// import koKR from './ko-KR/ko-KR';
// import daDK from './da-DK/da-DK';
// import deDE from './de-DE/de-DE';
// import es419 from './es-419/es-419';
// import fiFI from './fi-FI/fi-FI';
// import frFR from './fr-FR/fr-FR';
// import itIT from './it-IT/it-IT';
// import nbNO from './nb-NO/nb-NO';
// import nlNL from './nl-NL/nl-NL';
// import plPL from './pl-PL/pl-PL';
// import ptBR from './pt-BR/pt-BR';
// import ruRU from './ru-RU/ru-RU';
// import svSE from './sv-SE/sv-SE';
// import zhTW from './zh-TW/zh-TW';

const AllLocales = {
    'en-US':enUS,
    // 'zh-CN':zhCN,
    // 'ja-JP':jaJP,
	// 'ko-KR':koKR,
	// 'da-DK':daDK,
	// 'de-DE':deDE,
	// 'es-419':es419,
	// 'fi-FI':fiFI,
	// 'fr-FR':frFR,
	// 'it-IT':itIT,
	// 'nb-NO':nbNO,
	// 'nl-NL':nlNL,
	// 'pl-PL':plPL,
	// 'pt-BR':ptBR,
	// 'ru-RU':ruRU,
	// 'sv-SE':svSE,
	// 'zh-TW':zhTW
}

export {
    enUS,
    // zhCN,
    // jaJP,
	// koKR,
	// daDK,
	// deDE,
	// es419,
	// fiFI,
	// frFR,
	// itIT,
	// nbNO,
	// nlNL,
	// plPL,
	// ptBR,
	// ruRU,
	// svSE,
	// zhTW,
    AllLocales
}